<template src="./template.html"></template>

<script>
  import ModuleMapping from '@/config/modules-mapping'
  import { find, isUndefined } from 'lodash'

  export default {
    name: 'ComponentLoader',
    components: {
      ...ModuleMapping.modulesImport,
    },
    props: {
      componentType: {
        type: String,
        default: () => null,
      },
      options: {
        type: Object,
        default: () => {},
      },
      commentsActive: Boolean,
      moduleId: Number,
    },
    computed: {
      componentLoader() {
        const type = find(ModuleMapping.modulesMapping(), m => m.type === this.componentType)
        return !isUndefined(type) ? type.component : false
      },
    },
  }
</script>
